module.exports = __webpack_public_path__ + "favicon-120-9af70bfe5f39c38422b1c9814f842bf6.bundle.png";